import { loc } from "../i18n/survey";
import { locIconButton } from "./utils";

enum Equipment {
  FullCommercialGym = 'FullCommercialGym',
  LimitedGym = 'LimitedGym',
  FullHomeGym = 'FullHomeGym',
  DumbellsOnly = 'DumbellsOnly',
  ResistanceBandsOnly = 'ResistanceBandsOnly',
  Bodyweight = 'Bodyweight',
}

const equipmentQuestion = {
  name: 'equipment',
  title: loc("quiz.equipment.title"),
  description: loc("quiz.equipment.description"),
  type: 'radiogroup',
  choices: [
    {
      value: Equipment.FullCommercialGym,
      text: locIconButton("quiz.equipment.choices.fullGym"),
    },
    {
      value: Equipment.LimitedGym,
      text: locIconButton("quiz.equipment.choices.limitedGym"),
    },
    {
      value: Equipment.FullHomeGym,
      text: locIconButton("quiz.equipment.choices.homeGym"),
    },
    {
      value: Equipment.DumbellsOnly,
      text: locIconButton("quiz.equipment.choices.dumbbells"),
    },
    {
      value: Equipment.ResistanceBandsOnly,
      text: locIconButton("quiz.equipment.choices.bands"),
    },
    {
      value: Equipment.Bodyweight,
      text: locIconButton("quiz.equipment.choices.bodyweight"),
    },
  ],
  // showOtherItem: true,
  isRequired: true,
};

export {
  Equipment,
  equipmentQuestion,
}